
<!--

  -->
<template>
  <div>Logging out . . .</div>
</template>

<script>
import Vue from 'vue'
// Vue.forceUpdate();

export default {
  mounted () {
    this.$store.commit('setIsLoggedIn', false)

    this.$parent.show = false
    this.$router.push('/')

    // this.$parent.$forceUpdate();

    this.$emit('update-cart', { message: 'Successful' })
  }
}
</script>
